import React from 'react'
import { Link } from 'react-router-dom'
import { Nav, NavItem } from 'reactstrap'
import { TServiceNavigationSection } from '../../types/serviceView'

type TProps = {
    sections: TServiceNavigationSection[]
    activeSectionId?: string
    className?: string
}

const ServiceSubmenu: React.FC<TProps> = ({
    sections,
    activeSectionId = 'all',
    className = '',
}) => {
    if (!sections.length) {
        return null
    }

    return (
        <Nav
            pills
            className={`service-submenu mb-3 ${className}`.trim()}
            data-testid="service-submenu"
        >
            {sections.map((section) => (
                <NavItem key={section.id} className="mr-2 mb-2">
                    <Link
                        to={section.path}
                        className={
                            `service-submenu__link ${
                                section.id === activeSectionId
                                    ? 'service-submenu__link--active'
                                    : ''
                            }`.trim()
                        }
                        data-testid="service-submenu-link"
                    >
                        {section.label}
                    </Link>
                </NavItem>
            ))}
        </Nav>
    )
}

export default ServiceSubmenu
